import { useMediaQuery } from 'react-responsive';
import theme from '~/theme';

export default {
  useIsMobile(): boolean {
    return useMediaQuery({ maxWidth: theme.breakpoints.sm });
  },
  useIsTablet(): boolean {
    return useMediaQuery({ maxWidth: theme.breakpoints.md });
  },
  useIsDesktop(): boolean {
    return useMediaQuery({ minWidth: 1920 });
  },
};
